/**
 * @zag/notifications/common
 *
 * Shared types, interfaces, and constants for the notifications domain.
 * This library contains:
 * - Channel type constants and TypeScript types (matching DB enums)
 * - NotificationChannel interface (pluggable channel abstraction)
 * - Dispatch input/output types
 * - Event type registry (extensible via declaration merging)
 */

export * from './lib/channel-types';
export * from './lib/channel.interface';
export * from './lib/dispatch.types';
export * from './lib/event-registry';
export * from './lib/webhook.model';
export * from './lib/preference.model';
